const scrollTop = () => {
  let scroll = document.querySelector('.scroll');
  let contactTop = document.querySelector('.top-contact');
  let linkScroll = document.querySelector('.nav__scroll');
  
  if(scroll != undefined) {
    if(scrollY > (window.innerHeight / 2) && scrollY < contactTop.offsetTop - window.innerHeight) {
      scroll.classList.add('show');
      linkScroll.classList.add('show');
    }

    else {
      scroll.classList.remove('show');
      linkScroll.classList.remove('show');
    }
  }
}

export default scrollTop